<template>
    <Row class="full">
        <Col style="height: 100%" span="6">
            <Tree :data="community.buildings"
                  :render="renderTree"
                  @on-toggle-expand="onToggleExpand"
                  ref="refTree">
            </Tree>
        </Col>
        <Col style="height: 100%" span="18">
            <Card shadow>
                <Row type="flex" justify="center" style="margin: 10px 0">
                    <h2>{{community.name}} {{current.building.name}} {{current.unit.name}} {{current.door.name}}</h2>
                </Row>
                <Row>
                    <template v-if="!showModal">
                        <Button class="margin-top-10" v-if="showAddBtn" type="primary" long @click="addchild">{{current.buttonText}}</Button>
                        <Button class="margin-top-10"  v-if="!!current.node.id" type="warning" long @click="preEdit">{{$t('l.edit_name')}}</Button>
                        <Button class="margin-top-10"  v-if="!!current.node.id" type="error" long @click="preDelete">{{$t('l.delete')}}</Button>
                    </template>
                </Row>
                <div v-if="showModal">
                    <Row class="margin-top-10">
                        <Row style="display: flex;align-items: center;">
                            <span class="text-font-size"><strong>{{$t('l.create_type')}}：</strong></span>
                            <RadioGroup v-model="addConfig.newWay" type="button" size="default">
                                <Radio :label="1">{{$t('l.single')}}</Radio>
                                <Radio :label="0">{{$t('l.batch')}}</Radio>
                            </RadioGroup>
                        </Row>
                        <Row v-if="!addConfig.newWay" class="margin-top-10">
                            <Col span="12" v-if="addConfig.type === 'community'">
                                <Card><strong>{{$t('l.batch_add_build')}}：</strong><Checkbox v-model="addConfig.building.using" :disabled="true"></Checkbox></Card>
                            </Col>
                            <Col span="12" v-if="addConfig.building.using || addConfig.type === 'building'">
                                <Card><strong>{{$t('l.batch_add_unit')}}：</strong>
                                  <Checkbox v-model="addConfig.unit.using" @on-change="addConfig.door.using=false" :disabled="addConfig.type === 'building'"></Checkbox></Card>
                            </Col>
                            <!--<Col span="8" v-if="addConfig.unit.using || addConfig.type === 'unit'">-->
                                <!--<Card><strong>批量生成住户：</strong><Checkbox v-model="addConfig.door.using" :disabled="addConfig.type === 'unit'"></Checkbox></Card>-->
                            <!--</Col>-->
                        </Row>
                    </Row>

                    <!--单独创建-->
                    <Row class="margin-top-10" v-if="addConfig.newWay">
                        <Form :label-width="80">
                            <FormItem :label="currentObj.typeText+ ' ' + $t('l.name1')">
                                <Input v-model="currentObj.name" :placeholder="$t('l.remark73')" ></Input>
                            </FormItem>
                        </Form>
                    </Row>

                    <!--批量创建-->
                    <Row class="margin-top-10 community-building" v-else>
                        <!--楼-->
                        <Col span="12" v-if="addConfig.type === 'community'" class="shadow-box">
                            <Card>
                                <Form :label-width="100" label-position="left">
                                    <FormItem :label="$t('l.build_pre')">
                                        <Input style="width:80px" v-model="addConfig.building.prefix"/>
                                        <span class="margin-left-5">{{$t('l.hint23')}}</span>
                                    </FormItem>
                                    <FormItem :label="$t('l.build_suf')">
                                        <Input style="width:80px" v-model="addConfig.building.suffix"/>
                                        <span class="margin-left-5">{{$t('l.hint24')}}</span>
                                    </FormItem>
                                    <FormItem :label="$t('l.no_type')">
                                        <RadioGroup v-model="addConfig.building.serialType" type="button" size="small" @on-change="addConfig.diySerial = []">
                                            <Radio :label="0">{{$t('l.number1')}}</Radio>
                                            <Radio :label="1">{{$t('l.letter')}}</Radio>
                                            <Radio :label="2">{{$t('l.customize')}}</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    <FormItem v-if="addConfig.building.serialType<2" :label="$t('l.start_no')">
                                        <InputNumber v-if="addConfig.building.serialType === 0" v-model="addConfig.building.start" :max="addConfig.building.end"/>
                                        <Select v-else v-model="addConfig.building.start">
                                            <Option v-for="(item, index) in addConfig.letters" :value="index" :key="index">{{ item }}</Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem v-if="addConfig.building.serialType<2" :label="$t('l.end_no')">
                                        <InputNumber v-if="addConfig.building.serialType === 0" :min="addConfig.building.start" v-model="addConfig.building.end" />
                                        <Select v-else v-model="addConfig.building.end">
                                            <Option v-for="(item, index) in addConfig.letters" :value="index" :key="index" v-if="index >= addConfig.building.start">{{ item }}</Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem v-if="addConfig.building.serialType === 2" :label="$t('l.build_no')">
                                        <div style="max-height: 100px; overflow-y: auto;" id="diy_building_name">
                                            <Tag v-for="(serialName, index_serial) in addConfig.diySerial" :key="index_serial" closable @on-close="addConfig.diySerial.splice(index_serial, 1)">{{serialName}}</Tag>
                                        </div>

                                        <Row><Input :placeholder="$t('l.hint18')" @on-enter="addBuildingSerialName"/></Row>
                                        <Row style="color: #1cad90;">{{$t('l.hint25')}}</Row>
                                    </FormItem>
                                </Form>
                                <Row>
                        <span class="weight-font">
                            {{$t('l.create_build_name')}}：{{addConfig.building.prefix}}
                            {{addConfig.building.serialType===2?(addConfig.diySerial[0]||''):(addConfig.building.serialType?addConfig.letters[addConfig.building.start]:addConfig.building.start)}}
                            {{addConfig.building.suffix}}
                            ~ {{addConfig.building.prefix}}
                            {{addConfig.building.serialType===2?(addConfig.diySerial[addConfig.diySerial.length-1]||''):(addConfig.building.serialType?addConfig.letters[addConfig.building.end]:addConfig.building.end)}}
                            {{addConfig.building.suffix}}
                        </span>
                                </Row>
                            </Card>
                        </Col>
                        <!--单元-->
                        <Col span="12" v-if="addConfig.unit.using || addConfig.type === 'building'" class="shadow-box">
                            <Card>
                                <Form :label-width="100" label-position="left">
                                    <FormItem :label="$t('l.unit_pre')">
                                        <Input style="width: 80px" v-model="addConfig.unit.prefix"/>
                                        <span class="margin-left-5">{{$t('l.hint26')}}</span>
                                    </FormItem>
                                    <FormItem :label="$t('l.unit_suf')">
                                        <Input style="width: 80px" v-model="addConfig.unit.suffix"/>
                                        <span class="margin-left-5">{{$t('l.hint27')}}</span>
                                    </FormItem>
                                    <FormItem :label="$t('l.no_type')">
                                        <RadioGroup v-model="addConfig.unit.serialType" type="button" size="small">
                                            <Radio :label="0">{{$t('l.number1')}}</Radio>
                                            <Radio :label="1">{{$t('l.letter')}}</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                    <FormItem :label="$t('l.start_no')">
                                        <InputNumber v-if="addConfig.unit.serialType === 0" v-model="addConfig.unit.start" :max="addConfig.unit.end"/>
                                        <Select v-else v-model="addConfig.unit.start">
                                            <Option v-for="(item, index) in addConfig.letters" :value="index" :key="index">{{ item }}</Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem :label="$t('l.end_no')">
                                        <InputNumber v-if="addConfig.unit.serialType === 0" :min="addConfig.unit.start" v-model="addConfig.unit.end" />
                                        <Select v-else v-model="addConfig.unit.end">
                                            <Option v-for="(item, index) in addConfig.letters" :value="index" :key="index" v-if="index >= addConfig.unit.start">{{ item }}</Option>
                                        </Select>
                                    </FormItem>
                                    <Row>
                            <span class="weight-font">
                                {{$t('l.create_unit_name')}}：{{addConfig.unit.prefix}}{{addConfig.unit.serialType?addConfig.letters[addConfig.unit.start]:addConfig.unit.start}}{{addConfig.unit.suffix}} ~ {{addConfig.unit.prefix}}{{addConfig.unit.serialType?addConfig.letters[addConfig.unit.end]:addConfig.unit.end}}{{addConfig.unit.suffix}}
                            </span>
                                    </Row>
                                </Form>
                            </Card>
                        </Col>
                        <!--住户-->
<!--                        <Col span="8" v-if="addConfig.door.using || addConfig.type === 'unit'" class="shadow-box">-->
<!--                            <Card>-->
<!--                                <Form :label-width="82">-->
<!--                                    <FormItem :label="$t('l.pre')">-->
<!--                                        <div v-if="addConfig.type !== 'unit'">-->
<!--                                            {{$t('l.customize')}} <i-switch v-model="addConfig.door.unitPrefix" size="small" class="false-yellow"></i-switch> {{$t('l.customize')}}-->
<!--                                        </div>-->
<!--                                        <div v-if="!addConfig.door.unitPrefix">-->
<!--                                            <Input v-model="addConfig.door.prefix" :placeholder="$t('l.customize_pre')"/>-->
<!--                                        </div>-->
<!--                                    </FormItem>-->
<!--                                    &lt;!&ndash;<FormItem label="总楼层">&ndash;&gt;-->
<!--                                    &lt;!&ndash;<InputNumber :min="1" :max="64" v-model="addConfig.door.totalFloor"/>&ndash;&gt;-->
<!--                                    &lt;!&ndash;</FormItem>&ndash;&gt;-->
<!--                                    <FormItem :label="$t('l.start_floor')">-->
<!--                                        <InputNumber :min="1" :max="addConfig.door.endFloor" v-model="addConfig.door.startFloor"/>-->
<!--                                    </FormItem>-->
<!--                                    <FormItem :label="$t('l.end_floor')">-->
<!--                                        <InputNumber :min="addConfig.door.startFloor" :max="64" v-model="addConfig.door.endFloor"/>-->
<!--                                    </FormItem>-->
<!--                                    <FormItem :label="$t('l.users_floor')">-->
<!--                                        <InputNumber :min="1" v-model="addConfig.door.doorNum"/>-->
<!--                                    </FormItem>-->
<!--                                    <FormItem :label="$t('l.delimiter')">-->
<!--                                        <Input v-model="addConfig.door.separator"/>-->
<!--                                    </FormItem>-->
<!--                                    <FormItem :label="$t('l.user_no_type')">-->
<!--                                        <RadioGroup v-model="addConfig.door.serialType" type="button" size="small">-->
<!--                                            <Radio :label="0">{{$t('l.number1')}}</Radio>-->
<!--                                            <Radio :label="1">{{$t('l.letter')}}</Radio>-->
<!--                                        </RadioGroup>-->
<!--                                    </FormItem>-->
<!--                                    <Row>-->
<!--                            <span class="weight-font">-->
<!--                                {{$t('l.create_user_name')}}：{{addConfig.door.unitPrefix?((addConfig.unit.serialType?addConfig.letters[addConfig.unit.start]:addConfig.unit.start) + addConfig.door.separator):(addConfig.door.prefix?(addConfig.door.prefix+addConfig.door.separator):'')}}{{addConfig.door.startFloor}}{{addConfig.door.separator}}{{addConfig.door.serialType?addConfig.letters[0]:getFormatNumber(1, addConfig.door.doorNum)}}-->
<!--                                ~-->
<!--                                {{addConfig.door.unitPrefix?((addConfig.unit.serialType?addConfig.letters[addConfig.unit.start]:addConfig.unit.start) + addConfig.door.separator):(addConfig.door.prefix?(addConfig.door.prefix+addConfig.door.separator):'')}}{{addConfig.door.endFloor}}{{addConfig.door.separator}}{{addConfig.door.serialType?addConfig.letters[addConfig.door.doorNum-1]:addConfig.door.doorNum}}-->
<!--                            </span>-->
<!--                                    </Row>-->
<!--                                </Form>-->

<!--                            </Card>-->
<!--                        </Col>-->
                    </Row>
                    <div class="margin-top-10 submit-button-box">
                        <Button @click="showModal=false">{{$t('l.close')}}</Button>
                        <Button class="margin-left-10" v-if="addConfig.newWay" :loading="addConfig.loading" type="primary" @click="onAdd" >{{$t('l.save')}}</Button>
                        <Button class="margin-left-10" v-else type="primary" @click="onBatchAdd" :loading="addConfig.loading">{{$t('l.batch_add')}}</Button>
                    </div>
                </div>
                <lg-modal  :show="showModalEdit"
                        :title="$t('l.set') + contextMenu.currentObj.name" >
                    <Form :label-width="60" v-if="contextMenu.currentObj.type">
                        <FormItem :label="frameConfig[contextMenu.currentObj.type].text +' ' +  $t('l.name1')">
                            <Input v-model="editObj.name" :placeholder="$t('l.remark73')"></Input>
                        </FormItem>
                    </Form>
                </lg-modal>
            </Card>
        </Col>
    </Row>
</template>

<script>
    import util from '@/libs/util';
    import lgModal from "../../my-components/lg-modal";

    export default {
        name: "community-detail",
        components:{lgModal},
        props: {
            community: Object
        },
        data(){
            return {
                current: {
                    node: {},
                    buttonText: this.$t('l.add_build'),
                    building: {},
                    unit: {},
                    door: {}
                },
                showAddBtn: true,
                addConfig: {
                    loading: false,
                    type: 'building',
                    newWay: 1,
                    letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                    diySerial: [],
                    building: {
                        using: false,
                        suffix: '#' + this.$t('l.build'),
                        prefix: '',
                        start: 1,
                        end: 10,
                        serialType: 0
                    },
                    unit: {
                        using: false,
                        suffix: this.$t('l.unit'),
                        prefix: '',
                        start: 1,
                        end: 2,
                        serialType: 0
                    },
                    door: {
                        prefix: '',
                        using: false,
                        unitPrefix: true,
                        startFloor: 1,
                        endFloor: 2,
                        totalFloor: 10,
                        doorNum: 2,
                        separator: '-',
                        serialType: 0
                    }
                },
                showModal: false,
                spinShow: false,
                showModalEdit: false,
                contextMenu: {
                    position: {x: 0, y: 0},
                    menus: [],
                    show: false,
                    currentObj: {}
                },
                communityTree: [],
                frameConfig: {
                    community: {
                        text: this.$t('l.community'),
                        child: this.$t('l.build'),
                        childType: 'building',
                        icon: 'home',
                        weight: 4
                    },
                    building: {
                        text: this.$t('l.build'),
                        child: this.$t('l.unit'),
                        childType: 'unit',
                        icon: 'calculator',
                        weight: 3
                    },
                    unit: {
                        text: this.$t('l.unit'),
                        child: this.$t('l.tenement'),
                        childType: 'door',
                        icon: 'ios-box',
                        weight: 2
                    },
                    door: {
                        text:  this.$t('l.tenement'),
                        icon: 'android-contacts',
                        weight: 1
                    }
                },
                activeId: 0,
                currentObj: {
                    type: 'community',
                },
                expandNodes: [],
                editObj: {},
                parentKey: null
            }
        },
        watch: {
            community: {
                handler (newCommunity) {
                    if (!newCommunity || !newCommunity.j_buildings) return;
                    newCommunity.j_buildings.forEach(b => {
                        b.title = b.name;
                        b.type = 'building';
                        b.children = b.units || [];
                        b.children.forEach(u => {
                            u.title = u.name;
                            u.type = 'unit';
                            u.children = u.doors || [];
                            u.children.forEach(d => {
                                d.type = 'door';
                                d.title = d.name;
                            })
                        })
                    })
                    newCommunity.buildings = [{
                        id: 0,
                        title: newCommunity.name,
                        name: newCommunity.name,
                        type: 'community',
                        expand: true,
                        children: newCommunity.j_buildings || []
                    }]
                    this.current.building = this.current.unit = this.current.door = {};
                    this.activeId = 0;
                    this.current.buttonText = this.$t('l.add_build');
                    this.showAddBtn = true;
                    this.current.node = this.currentObj = newCommunity.buildings[0];
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            onTreeSelect (nodes, node, current) {
                this.showModal = false;
                let addText = this.$t('l.add_build');
                if (this.activeId === current.id) {
                    this.activeId = 0;
                    this.current.building = this.current.unit = this.current.door = {};
                    addText = this.$t('l.add_build');
                    this.showAddBtn = true;
                    this.current.node = this.currentObj = this.community.buildings[0];
                } else {
                    this.activeId = current.id; // 1
                    switch (current.type) {
                        case 'building':
                            this.showAddBtn = true;
                            addText = this.$t('l.add_unit');
                            break;
                        case 'unit':
                            this.showAddBtn = false;
                            // addText = '住户';
                            break;
                        // case 'door':
                        //     this.showAddBtn = false;
                        //     break;
                    }
                    this.current.node = current;
                    this.currentObj = current;
                }
                this.current.buttonText = addText;
                if (this.activeId) this.setParents(nodes, node);
            },
            setParents (nodes, node) {
                this.parentKey = node.parent;
                switch (node.node.type) {
                    case 'community':
                        this.current.building = {};
                        this.current.unit = {};
                        this.current.door = {};
                        break;
                    case 'building':
                        this.current.building = node.node;
                        this.current.unit = {};
                        this.current.door = {};
                        break;
                    case 'unit':
                        this.current.building = nodes.find(n => n.nodeKey === node.parent).node;
                        this.current.unit = node.node;
                        this.current.door = {};
                        break;
                    case 'door':
                        let unitNode = nodes.find(n => n.nodeKey === node.parent);
                        this.current.unit = unitNode.node;
                        this.current.building = nodes.find(n => n.nodeKey === unitNode.parent).node;
                        this.current.door = node.node;
                        break;
                }
            },
            addBuildingSerialName (e) {
                let value = e.target.value;
                if (!value || !value.trim()) {
                    this.$Message.warning(this.$t('l.hint18'));
                    return;
                }
                value = value.trim();
                if (this.addConfig.diySerial.includes(value)) {
                    this.$Message.warning(this.$t('l.hint19'));
                    return;
                }
                this.addConfig.diySerial.push(value);
                e.target.value = '';
                setTimeout(() => {
                    let ele = document.getElementById('diy_building_name');
                    ele.scrollTop = ele.scrollHeight;
                }, 100);
            },
            onBatchAdd () {
                let names = {
                    buildings: [],
                    units: [],
                    doors: []
                }

                if (this.addConfig.building.start >= this.addConfig.building.end || this.addConfig.unit.start > this.addConfig.unit.end || !this.addConfig.building.end || !this.addConfig.unit.end) {
                    this.$Message.warning(this.$t('l.hint20'));
                    this.addConfig.loading = false;
                    return;
                }


                if (this.addConfig.building.using) {
                    if (this.addConfig.building.serialType === 2) {
                        if (!this.addConfig.diySerial.length) {
                            this.$Message.warning(this.$t('l.hint21'));
                            return;
                        }
                        for (let i = 0; i < this.addConfig.diySerial.length; i++) {
                            let buildingNum = this.addConfig.diySerial[i];
                            names.buildings.push({
                                name: this.addConfig.building.prefix + buildingNum + this.addConfig.building.suffix,
                                units: []
                            });
                        }
                    } else {
                        for (let i = this.addConfig.building.start; i <= this.addConfig.building.end; i++) {
                            let buildingNum = this.addConfig.building.serialType ? this.addConfig.letters[i] : i;
                            names.buildings.push({
                                name: this.addConfig.building.prefix + buildingNum + this.addConfig.building.suffix,
                                units: []
                            });
                        }
                    }
                }

                if (this.addConfig.unit.using) {
                    for (let i = this.addConfig.unit.start; i <= this.addConfig.unit.end; i++) {
                        let unitNum = this.addConfig.unit.serialType ? this.addConfig.letters[i] : i;
                        let doors = [];
                        if (this.addConfig.door.using) {
                            let doorPrefix = this.addConfig.door.prefix ? (this.addConfig.door.prefix + this.addConfig.door.separator) : '';
                            if (this.addConfig.door.unitPrefix) { // 如果使用单元前缀
                                doorPrefix = unitNum + this.addConfig.door.separator;
                            }
                            for (let floor = this.addConfig.door.startFloor; floor <= this.addConfig.door.endFloor; floor++) {
                                for (let j = 0; j < this.addConfig.door.doorNum; j++) {
                                    doors.push({
                                        name: doorPrefix + floor + this.addConfig.door.separator + (this.addConfig.door.serialType ? this.addConfig.letters[j] : (j + 1))
                                    });
                                }
                            }
                        }
                        names.units.push({
                            name: this.addConfig.unit.prefix + unitNum + this.addConfig.unit.suffix,
                            doors: doors
                        });
                    }
                } else if (this.addConfig.door.using) {
                    let doors = [];
                    let doorPrefix = this.addConfig.door.prefix ? (this.addConfig.door.prefix + this.addConfig.door.separator) : '';
                    for (let floor = this.addConfig.door.startFloor; floor <= this.addConfig.door.endFloor; floor++) {
                        for (let j = 0; j < this.addConfig.door.doorNum; j++) {
                            doors.push({
                                name: doorPrefix + floor + this.addConfig.door.separator + (this.addConfig.door.serialType ? this.addConfig.letters[j] : this.getFormatNumber(j + 1, this.addConfig.door.doorNum))
                            });
                        }
                    }
                    names.doors = doors;
                }

                let data = {
                    communityId: this.community.id,
                    fatherType: this.addConfig.type,
                    fatherId: this.current.node.id,
                    names: names
                };


                let oldchildrenNames = this.current.node.children.map(oldChild => {
                    return oldChild.name;
                });

                let addChildrenNames = names[this.currentObj.type + 's'].map(addChild => {
                    return addChild.name;
                });
                if (new Set(oldchildrenNames.concat(addChildrenNames)).size < oldchildrenNames.length+addChildrenNames.length) {
                    this.$Message.warning(this.$t('l.hint49') + " " + this.currentObj.typeText);
                    return;
                }
                this.addConfig.loading = true;

                util.ajax.post('/community/addchildren', data, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    this.addConfig.loading = false;
                    if (!res.code) {
                        this.$Message.success(this.$t('l.add_success'));
                        this.showModal = false;
                    }
                    this.refreshCommunity();
                });
            },
            getFormatNumber (num, max) {
                let len = max.toString().length;
                return ('0'.repeat(len) + num).slice(-len);
            },
            packCommunityTree () {
                let buildings = util.deepCopy(this.community.j_buildings);
                if (buildings) {
                    buildings.map((building) => {
                        if (this.expandNodes.includes(building.id)) {
                            building.expand = true;
                        }
                        building.type = 'building';
                        building.children = building.units || [];
                        building.children.map((unit) => {
                            if (this.expandNodes.includes(unit.id)) {
                                unit.expand = true;
                            }
                            unit.type = 'unit';
                            unit.children = unit.doors || [];
                            unit.children.map((door) => {
                                door.type = 'door';
                            });
                        });
                    });
                } else {
                    buildings = [];
                }

                let community = [{
                    id: -1, // 虚拟id，为区分children中的id，不参与其他逻辑
                    name: this.$store.state.app.community.community_name,
                    children: buildings,
                    expand: true,
                    type: 'community'
                }];
                util.arrItemSort(community[0].children,"name",0);
                // util.compareArray(community[0].children,'name',true);
                // community[0].children.sort(function (a, b) { // 返回值小于0 a在前，等于0 不变， 大于0 b在前
                //     return a.name.replace(/[^x00-xff]/g,"01").length-b.name.replace(/[^x00-xff]/g,"01").length;
                // });
                community[0].children.forEach(building=>{
                    if(building.units && building.units.length){
                        util.arrItemSort(building.units,"name",0);
                        // util.compareArray(building.units,'name',true);
                        // building.units.sort(function (a, b) { // 返回值小于0 a在前，等于0 不变， 大于0 b在前
                        //     return a.name.replace(/[^x00-xff]/g,"01").length-b.name.replace(/[^x00-xff]/g,"01").length;
                        // });
                        building.units.forEach(unit=>{
                            if(unit.doors && unit.doors.length) {
                                util.arrItemSort(unit.doors,"name",0);
                                // util.compareArray(unit.doors,'name',true);
                                // unit.doors.sort(function (a, b) { // 返回值小于0 a在前，等于0 不变， 大于0 b在前
                                //     return a.name.replace(/[^x00-xff]/g,"01").length-b.name.replace(/[^x00-xff]/g,"01").length;
                                // });
                            }
                        });
                    }
                });
                this.communityTree = community;
            },
            addchild () {
                if (!this.current.node.type) this.current.node = this.community.buildings[0];
                let obj = this.current.node;
                let type = obj.type;
                this.addConfig.type = type;
                this.addConfig.building.using = false;
                this.addConfig.unit.using = false;
                this.addConfig.door.using = false;
                if (type !== 'door') this.addConfig[this.frameConfig[type].childType].using = true;
                if (type === 'unit') this.addConfig.door.unitPrefix = false;
                this.addConfig.loading = false;
                this.showModal = true;
                this.addConfig.newWay = 1;
                this.currentObj = {
                    type: this.frameConfig[obj.type].childType,
                    typeText: this.frameConfig[this.frameConfig[obj.type].childType].text,
                    actionType: this.$t('l.add'),
                    name: ''
                };

            },
            onAdd () {
                let obj = this.currentObj;
                if (!obj.name || !obj.name.trim().length) {
                    this.$Message.warning(this.$t('l.hint22'));
                    return;
                }
                this.addConfig.loading = true;
                let param = {
                    commID: this.community.id,
                    obj: {
                        name: obj.name
                    },
                    path: ''
                };
                let children = this.current.node.children;
                for (let i = 0; i < children.length; i++) {
                    let child = children[i];
                    if (child.name === obj.name) {
                        this.$Message.warning(this.$t('l.hint49') + ' ' + this.currentObj.typeText);
                        return;
                    }
                }
                switch (obj.type) {
                    case 'building':
                        param.obj.units = [];
                        param.obj.month_price = obj.month_price;
                        param.path = '$';
                        break;
                    case 'unit':
                        param.obj.doors = [];
                        let ppid = this.current.node.id;
                        this.community.j_buildings.map((building, index) => {
                            if (building.id === ppid) {
                                param.path = '$[' + index + '].units';
                            }
                        });
                        break;
                    case 'door':
                        let pid = this.current.node.id;
                        this.community.j_buildings.map((building, index) => {
                            building.units.map((unit, index1) => {
                                if (unit.id === pid) {
                                    param.path = '$[' + index + '].units[' + index1 + '].doors';
                                }
                            });
                        });
                        break;
                }
                util.ajax.post('/community/addchild', param).then((res) => {
                    if (!res.code) {
                        this.showModal = false;
                        this.$Message.success(this.$t('l.success'));
                        this.refreshCommunity();
                    }
                    this.addConfig.loading = false;
                });
            },
            /**
             * 选中右键菜单（索引顺序）
             * @param index
             */
            onMenuSelect (index) {
                this[this.contextMenu.menus[index].callback]();
            },
            refreshCommunity () {
                util.ajax.get('/community/getbyid', {params: {id: this.community.id}}).then((res) => {
                    this.$emit('on-refresh', res.data)
                });
            },
            onToggleExpand (node) {
                if (node.expand) {
                    this.expandNodes.push(node.id);
                } else {
                    this.expandNodes.splice(this.expandNodes.indexOf(node.id), 1);
                }
            },
            preEdit () {
                let name = this.current.node.name;
                this.$Modal.confirm({
                    title: this.$t('l.rename') + " " + name,
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: name
                            },
                            on: {
                                input: (e) => {
                                    name = e;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        if (name === this.current.node.name) {
                            this.$Message.warning(this.$t('l.hint33'));
                        }else{
                            util.ajax.put('/community/editchild', {
                                building: this.current.building.id,
                                unit: this.current.unit.id,
                                door: this.current.door.id,
                                community: this.community.id,
                                name
                            }).then((res) => {
                                this.$Message.success(this.$t('l.edit_success'));
                                this.refreshCommunity();
                            });
                        }
                    }
                });
            },
            preDelete () {
                this.$Modal.confirm({
                    // content: '确定删除 <b>' + this.current.node.name + '</b>？',
                    render:(h,parm)=>{
                            return h('div', [
                                h('div',{style:{display:'flex'}},[
                                    h('Icon', {
                                        props:{
                                            type:"ios-alert",
                                            color:'#e67e22',
                                            size:'30'
                                        },
                                    }),
                                    h('h3', {
                                        style:{
                                            marginLeft: "10px",
                                            display: "flex",
                                            alignItems: "center"
                                        }
                                    },this.$t('l.warn')),
                                ]),
                                h('p', {
                                    style:{
                                        fontSize:'16px',
                                        fontWeight:500,
                                        marginLeft:'40px'
                                    }
                                },this.$t('l.hint34') + this.current.node.name+"  ？"),
                            ])
                    },
                    onOk: () => {
                        util.ajax.delete('/community/deletechild', {
                            params: {
                                building: this.current.building.id,
                                unit: this.current.unit.id,
                                door: this.current.door.id,
                                community: this.community.id
                            }
                        }).then((res) => {
                            if (!res.code) {
                                this.$Message.success(this.$t('l.delete_success'));
                                this.refreshCommunity();
                            }else{

                            }
                        });
                    }
                });
            },
            edit () {
                this.showModalEdit = true;
                this.editObj.id = this.current.node.id;
                this.editObj.name = this.current.node.name;
                this.editObj.type = this.current.node.type;
            },
            onModify () {
                if (this.editObj.name === this.current.node.name) {
                    this.$Message.warning(this.$t('l.hint50'));
                    return;
                }
                let parent = this.$refs.refTree.flatState[this.parentKey].node;
                let siblings = parent.children;
                for (let i = 0; i < siblings.length; i++) {
                    let child = siblings[i];
                    if (child.name === this.editObj.name) {
                        this.$Message.warning(this.$t('l.hint51') + " " + this.frameConfig[this.current.node.type].text );
                        return;
                    }
                }
                util.ajax.put('/community/modify', this.editObj).then(res => {
                    if (!res.code) {
                        this.showModalEdit = false;
                        this.$Message.success(this.$t('edit_success'));
                        this.refreshCommunity();
                        this.$store.commit('refreshLifts');
                        this.$emit('on-update');
                    }
                });
            },
            renderTree (h, { root, node, data }) {
                return h('span', {
                    style: {
                        display: 'inline-block',
                        width: '90%'
                    },
                    class: {
                        'tree-item': true
                    }
                }, [
                    h('span', [
                        h('Icon', {
                            props: {
                                type: this.frameConfig[data.type].icon || 'ios-film'
                            },
                            style: {
                                marginRight: '3px'
                            }
                        }),
                        h('span', {
                            on: {
                                click: () => {
                                    this.onTreeSelect(root, node, data);
                                }
                            },
                            class: {
                                'tree-line': true,
                                'active': this.activeId === data.id
                            },
                            style: {
                                padding: '1px 5px',
                                borderRadius: '2px'
                            }
                        }, data.name)
                    ])
                ]);
            }
        },
        mounted(){

        }
    }
</script>

<style scoped lang="less">
.submit-button-box{
    display: flex;
    width: 100%;
    justify-content: flex-end;
}
</style>